export default (text?: string) => {
  return text ? text.toLowerCase().replace(/\s/g, '-') : '';
};



// WEBPACK FOOTER //
// ./src/utils/getSlug.ts